import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext'; // Import useAuth hook
import OtpInput from 'react-otp-input';
import { useNavigate } from 'react-router-dom';

import { MdLock, MdOutlineRefresh } from "react-icons/md";
import PrivateRoute from '../../components/PrivateRoute';
import NavBar from '../Common/NavBar';
import BancoPortugalInfo from '../Common/BancoPortugalInfo';
import CopyrightInfo from '../Common/CopyrightInfo';
import { gtmUserAlreadyLoggedIn, gtmOtpRequestSent, gtmOtpRequestFailed, gtmOtpVerificationSuccess, gtmOtpVerificationFailed, gtmOtpVerificationError, gtmOtpResent, gtmOtpResendFailed } from '../../components/GtmEvents';


const LoginScreen = () => {
    const [input, setInput] = useState('');
    const [otp, setOtp] = useState('');
    const [showOtpInput, setShowOtpInput] = useState(false);
    const [error, setError] = useState("");
    const [countdown, setCountdown] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const { requestOtp, verifyOtp } = useAuth();
    const navigate = useNavigate();
    const { user } = useAuth();

    useEffect(() => {
        if (user) {
            gtmUserAlreadyLoggedIn();
            navigate('/dashboard');
        } else {
            navigate('/login');
        }

        if (countdown > 0) {
            const interval = setInterval(() => {
                setCountdown(countdown - 1);
            }, 1000);

            return () => clearInterval(interval);
        }
    }, [showOtpInput, countdown, user, navigate]);

    const handleEmailSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            await requestOtp(input);
            setShowOtpInput(true);
            setCountdown(180);
            gtmOtpRequestSent();

        } catch (error) {
            console.error('Error requesting OTP:', error);
            setError('Verifique por favor a validade dos dados introduzidos.');
            gtmOtpRequestFailed();
        } finally {
            setIsLoading(false);
        }
    };

    const handleOtpSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        const accessToken = localStorage.getItem('accessToken');
        const inputFromStorage = localStorage.getItem('input');

        try {
            const response = await verifyOtp(inputFromStorage, otp, accessToken);

            if (response && response.valid) {
                localStorage.setItem('sessionToken', response.sessionToken);
                navigate('/dashboard');
                window.location.href = '/dashboard';
                gtmOtpVerificationSuccess();
            } else {
                setError(response.message || 'Invalid OTP. Please try again.');
                gtmOtpVerificationFailed();
            }
        } catch (error) {
            console.error('Error submitting OTP:', error);
            setError('Invalid OTP or an error occurred during OTP verification.');
            gtmOtpVerificationError();
        } finally {
            setIsLoading(false);
        }
    };

    const handleResendOtp = async () => {
        try {
            await requestOtp(input);
            setCountdown(180);
            gtmOtpResent();
        } catch (error) {
            console.error('Error resending OTP:', error);
            setError('An error occurred while attempting to resend the OTP.');
            gtmOtpResendFailed();
        }
    };

    return (
        <div>
            <NavBar className="" />
            <div className="flex justify-center bg-[#F3F4F6] container-noNav">
                <div className="w-full p-10 ml-5 mr-5 max-w-screen-xl justify-center xs:p-4 xs:py-6">

                    <BancoPortugalInfo />

                    <h2 className="text-lg md:text-lg sm:text-base">
                        <span className="font-bold">Bem-vindo ao Estado do Processo</span><br />
                        <span className="text-base md:text-base sm:text-12 block mt-6">Introduza o <span className="font-bold">endereço de email</span> ou <span className="font-bold">número de telefone</span> que indicou no seu pedido de crédito para verificar o estado do seu processo ou avançar com a pré-aprovação.</span>
                    </h2>

                    <div className="w-full max-w-screen-xl mx-auto px-4 grid grid-cols-5 gap-4 xs:px-0 xs:gap-0">
                        {/* Coluna da esquerda (1/4) */}
                        <div></div>

                        {/* Coluna central (2/4) */}
                        <div className="col-span-3 xs:col-span-5">

                            {showOtpInput ? (
                                <form className="mt-20 mb-10 otp-form" onSubmit={handleOtpSubmit}>
                                    <label htmlFor="otp-code" className='mb-4 block text-center text-base md:text-base sm:text-sm font-medium text-dark'>Introduza o código recebido por SMS</label>
                                    <OtpInput
                                        value={otp}
                                        onChange={setOtp}
                                        numInputs={6}
                                        inputStyle={{
                                            border: "1px solid #25232C",
                                            margin: "0 4px",
                                            borderRadius: "8px",
                                            width: "60px",
                                            height: "60px",
                                            fontSize: "32px",
                                            color: "#000",
                                            fontWeight: "700",
                                            caretColor: "#B78B1E"
                                        }}
                                        className="otp-input justify-center"
                                        renderSeparator={<span>-</span>}
                                        renderInput={(props) => <input {...props} />}
                                    />

                                    <div className="mt-10 grid grid-cols-1">
                                        <button type="submit" className="mb-8 amco-blue hover:amco-blue/75 text-white font-bold py-2 px-4 rounded">
                                            {isLoading ? (
                                                <div className="spinner" />
                                            ) : (
                                                'Validar Código'
                                            )}
                                        </button>

                                        <a href="#" onClick={handleResendOtp} className="flex align-center place-content-center">
                                            <span className="text-xs text-center text-amco-blue">Não recebeu o código? Reenviar por SMS</span>
                                            <MdOutlineRefresh />
                                        </a>

                                    </div>
                                </form>
                            ) : (
                                <form className="mt-20 mb-10" onSubmit={handleEmailSubmit}>
                                    <label htmlFor="inputUserData" className='mb-4 block text-base md:text-base sm:text-sm font-medium font-medium text-dark'>Endereço de Email ou Telefone:</label>
                                    <input
                                        required
                                        name="inputUserData" id="inputUserData"
                                        type="text"
                                        value={input}
                                        placeholder='Introduza o seu endereço de email ou telefone'
                                        onChange={(e) => setInput(e.target.value)}
                                        className='mb-4 text-sm w-full bg-white rounded-md border border-stroke dark:border-dark-3 py-[10px] px-5 text-dark outline-none transition focus:amco-blue active:amco-blue disabled:cursor-default disabled:bg-gray-2 disabled:border-gray-2'
                                    />

                                    <div className="grid grid-cols-1">
                                        <button type="submit" className="mb-10 amco-blue hover:amco-blue/75 text-white font-bold py-2 px-4 rounded">
                                            {isLoading ? (
                                                <div className="spinner" />
                                            ) : (
                                                "Fazer Login"
                                            )}
                                        </button>


                                    </div>
                                </form>
                            )}

                        </div>

                        {/* Coluna da direita (1/4) */}
                        <div></div>
                    </div>

                    {error && <p className="text-red-500 text-center mt-4 mb-4">{error}</p>}


                    <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                        <p className="flex items-center text-sm text-green-700">
                            <span className="pr-3">
                                <MdLock />
                            </span>
                            Ligação Segura. Esta ligação é protegida por encriptação SSL de 256 bits.
                        </p>
                    </div>


                    <CopyrightInfo />
                </div>
            </div>
        </div>
    );
};

export default LoginScreen;
